import React from 'react'

import LotForm from '../../LotForm/LotForm'
import Api from '../../../services/api'
import BackButton from '../../BackButton/BackButton'
import { isOfferBoardAuction } from '../../../utils/OfferBoard'

const findDetailValue = (lot, groupTitle, publicId) => {
  let group = lot.details.values.find(detail => detail.title === groupTitle)
  if (!group) {
    return undefined
  }
  let field = group.values.find(item => item.publicId === publicId)
  return field ? field.value : undefined
}

export default class EditLate extends LotForm {
  constructor (props) {
    super(props)
    this.mode = 'edit-late'
    this.mainUrl = '/main/manage/edit-late'
  }

  isOfferBoard () {
    return isOfferBoardAuction(this.state.auction)
  }

  async submitLot (lot) {
    this.props.showSpinner(true)
    let data
    if (this.isOfferBoard()) {
      // On the Offer Board the Seller can also adjust the Delivery details of a
      // live listing. There is no Reserve Price - the Sell Price is the reserve.
      let sellPrice = lot.bidding !== 'kg' ? lot.startPrice * 100 : lot.startPrice
      data = {
        startPrice: sellPrice,
        reserveCents: sellPrice,
        adjustWeight: lot.adjustWeight,
        weightGain: findDetailValue(lot, 'Delivery', 'weightGain'),
        earliestDelivery: findDetailValue(lot, 'Delivery', 'earliestDelivery'),
        latestDelivery: findDetailValue(lot, 'Delivery', 'latestDelivery'),
        vendorSignedForm: lot.vendorSignedForm
      }
    } else {
      data = {
        startPrice: lot.bidding !== 'kg' ? lot.startPrice * 100 : lot.startPrice,
        reserveCents: lot.bidding !== 'kg' ? lot.reserveCents * 100 : lot.reserveCents
      }
    }
    let res = await Api.editLateLot(lot._id, data)
    if (res) {
      this.props.mergeStateProp('lots', [res.lot], 'data')
      this.props.history.push('/main/manage/my-submitted')
    }
    this.props.showSpinner(false)
  }

  validateDraftLot (draftLot) {
    let res = this.bidCentsValidation(draftLot)
    if (res.valid && this.isOfferBoard()) {
      if (!findDetailValue(draftLot, 'Delivery', 'earliestDelivery')) {
        return {
          valid: false,
          message: 'Please enter Earliest Delivery This is a required field*'
        }
      }
      if (!draftLot.vendorSignedForm) {
        return {
          valid: false,
          message: 'Please confirm the Vendor has signed off on the changes to this listing'
        }
      }
    }
    return res
  }
  componentDidUpdate (prevProps, prevState) {
    if ((prevProps.match.params.kindTitle !== this.props.match.params.kindTitle) ||
        (prevProps.match.params.draftId !== this.props.match.params.draftId)) {
      this.reloadPage()
    }
  }
  renderBackButton () {
    return (
      <BackButton onPress={() => {
        this.props.history.goBack()
      }} name='Back to My Submitted' />
    )
  }
  silentSubmitLot () {}
  pageBlock () {}
  renderSaveLaterBtn () {}
  getNotificationText () {}
  renderNotificationBlock () {}
  renderAuctionInfo () {}
}
